<div class="settings-page">
    <div class="settings-sidebar">
      <ul>
        @for (item of routeAccess; track item) {
          @if (showOption(item)) {
            <li (click)="selectOption(item.path)" [class.active]="isActive(item.path)">{{item.name}}</li>
          }
        }
      </ul>
    </div>
    <!-- The main content is now driven by Angular routing rather than conditionals -->
  <div class="settings-content">
    <router-outlet></router-outlet>
  </div>
</div>
  